import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 2C8473E2-22E8-4E6E-B929-99D2FCE9937B
 * name sawtooth-wave
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sawtooth-wave.svg
 * tags
 * - Audio 
 */
export const SawtoothWaveIcon = createSvgIcon(<><path d="M11 22V6.83L2 16V13.17L13 2V17.17L22 8V10.83L11 22Z" /></>, 'SawtoothWaveIcon');
export default SawtoothWaveIcon